import AsyncView from 'shopify-asyncview';
import rimg from 'rimg-shopify';
import ProductList from '../components/ProductList';

export default class StaticProductRecommendations {
  constructor(section) {
    const { productId } = section.data;
    const { limit } = section.data.settings;
    const recommendationsEl = section.el.querySelector('[data-product-recommendations]');

    this._loadRecommendations(recommendationsEl, productId, limit);
  }

  onSectionUnload() {
    if (this.productList) {
      this.productList.unload();
    }
  }

  _loadRecommendations(container, productId, limit) {
    const url = `${window.Theme.routes.product_recommendations_url}?section_id=static-product-recommendations&limit=${limit}&product_id=${productId}`;

    AsyncView.load(
      url,
    ).done(({ html }) => {
      container.innerHTML = html;

      rimg.watch(container);
      this.productList = new ProductList({ el: container });

      if (window.Shopify && Shopify.PaymentButton) {
        Shopify.PaymentButton.init();
      }
    });
  }
}
